export class InPostPointLocation {
  public constructor(
    private readonly data: {
      longitude: number;
      latitude: number;
    },
  ) {}

  public get longitude(): number {
    return this.data.longitude;
  }

  public get latitude(): number {
    return this.data.latitude;
  }
}
